module.exports = __webpack_public_path__ + "static/assets/sprite.40bc2eba.png";